module.exports = __webpack_public_path__ + "img/arrow-left.41a2bd7b.svg";